module.exports = __webpack_public_path__ + "img/a670c3a.png";